import createReducer from '../../../lib/createReducer';
import * as types from '../Actions/types';

export const initialState = {
    loading: false,
    patientDetails: {},
    validateUser: {},
    docList: [],
    roomKeys: [],
    callID: {},
    addUserStatus: {},
    notifyProvider: '',
    roomStatus: {},
    updateRoomStatusData: {},
    childrenList: [],
    selectedChildData: {},
    consentsData: false,
    consentsSigned: false,
    addChildren: false,
    addFamily: false,

    medicationsData: [],
    allergiesData: {},
    uploadSuccess: false,
    medicationStore: [],
    allergiesStore: [],
    medicalConditionStore: [],
    symptomsStore:[]
}

export const patientReducer = createReducer(initialState, {
    [types.GET_PATIENT_DETAILS](state, action) {
        return {
            ...state,
            patientId: action.patientId,
            token: action.token,
        };
    },
    [types.PATIENT_DETAILS_RESPONSE](state, action) {
        return {
            ...state,
            patientDetails: action.response,
        };
    },
    [types.GET_PATIENT_DETAILS_FAILED](state, action) {
        return {
            ...state,
            patientDetails: action.response,
        };
    },
    [types.VALID_CLIENT_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.VALID_CLIENT_RESPONSE](state, action) {
        return {
            ...state,
            validateUser: action.response,
        };
    },
    [types.VALID_CLIENT_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.CLEAR_DATA_RESPONSE](state) {
        return {
            ...state,
            validateUser: {},
            docList: [],
            roomKeys: [],
            callID: {},
            addUserStatus: {},
            notifyProvider: '',
            roomStatus: {},
            updateRoomStatusData: {},
        };
    },
    [types.GET_CHILDREN_REQUEST](state, params, token) {
        return {
            ...state,
            params,
            token,
            childrenList: [],
        };
    },
    [types.GET_CHILDREN_RESPONSE](state, action) {
        return {
            ...state,
            childrenList: action.response,
        };
    },
    [types.GET_CHILDREN_FAILED](state, action) {
        return {
            ...state,
            childrenList: [],
        };
    },
    [types.ADD_CHILDREN_REQUEST](state, params, token) {
        console.log("ADD_CHILDREN_REQUEST");
        return {
            ...state,
            params,
            token
        };
    },
    [types.ADD_CHILDREN_RESPONSE](state, action) {
        return {
            ...state,
            addChildren: true,
        };
    },
    [types.ADD_CHILDREN_FAILED](state, action) {
        return {
            ...state,
            addChildren: false,
        };
    },
    // add family
    [types.ADD_FAMILY_MEMBER_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.ADD_FAMILY_MEMBER_RESPONSE](state, action) {
        return {
            ...state,
            addFamily: action.response,
        };
    },
    [types.ADD_USER_DETAILS_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.ADD_USER_DETAILS_RESPONSE](state, action) {
        return {
            ...state,
            consentsData: true
        };
    },
    [types.ADD_USER_DETAILS_FAILED](state, action) {
        return {
            ...state,
            consentsData: false
        };
    },
    //to check user signed consents
    [types.GET_CHECK_USER_DETAILS_SIGNED](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.GET_CHECK_USER_DETAILS_SIGNED_RESPONSE](state, action) {
        return {
            ...state,
            consentsSigned: action.response.is_exists
        };
    },
    //Get Doc
    [types.GET_DOC_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.GET_DOC_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.GET_DOC_RESPONSE](state, action) {
        return {
            ...state,
            docList: action.response,
        };
    },
    //Get Room Keys
    [types.GET_ROOM_KEYS_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.GET_ROOM_KEYS_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.GET_ROOM_KEYS_RESPONSE](state, action) {
        return {
            ...state,
            roomKeys: action.response,
        };
    },
    //Generate CallID
    [types.GENERATE_CALLID_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.GENERATE_CALLID_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.GENERATE_CALLID_RESPONSE](state, action) {
        return {
            ...state,
            callID: action.response,
        };
    },
    //Add User to waiting
    [types.ADD_USER_TO_WAITING_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.ADD_USER_TO_WAITING_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.ADD_USER_TO_WAITING_RESPONSE](state, action) {
        return {
            ...state,
            addUserStatus: action.response,
        };
    },
    //Notify Provider
    [types.NOTIFY_PROVIDER_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.NOTIFY_PROVIDER_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.NOTIFY_PROVIDER_RESPONSE](state, action) {
        return {
            ...state,
            notifyProvider: action.response,
        };
    },
    //Check room status
    [types.CHECK_ROOM_STATUS_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.CHECK_ROOM_STATUS_FAILED](state) {
        return {
            ...state,
        };
    },
    [types.CHECK_ROOM_STATUS_RESPONSE](state, action) {
        return {
            ...state,
            roomStatus: action.response,
        };
    },
    [types.CALL_END_BY_PATIENT_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
            addUserStatus: {},
        };
    },
    [types.DISCONNECT_REASON_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.PROVIDER_SETTINGS_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    [types.INVALIDATE_REQUEST](state, payload, token) {
        return {
            ...state,
            payload,
            token,
        };
    },
    //Update room status
    [types.UPDATE_ROOM_STATUS](state, payload, token) {
        return {
            ...state,
            payload,
            token,
            updateRoomStatusData: {},
        };
    },
    [types.UPDATE_ROOM_STATUS_SUCCESS](state, action) {
        return {
            ...state,
            updateRoomStatusData: action.response,
        };
    },
    // To Add selected child 
    [types.ADD_SELECTED_CHILD](state, payload) {
        return {
            ...state,
            selectedChildData: payload.payload
        };
    },
    [types.REMOVE_SELECTED_CHILD](state, action) {
        return {
            ...state,
            selectedChildData: {}
        };
    },
    [types.MEDICATION_SEARCH](state, action) {
        return {
            ...state,
            query: action.query,
            medicationsData: [],
            token: action.token,
        };
    },
    [types.MEDICATION_SEARCH_SUCCESS](state, action) {
        return {
            ...state,
            medicationsData: action.response,
        };
    },
    [types.ALLERGY_SEARCH](state, action) {
        return {
            ...state,
            query: action.query,
            allergiesData: {},
            token: action.token,
        };
    },
    [types.ALLERGY_SEARCH_SUCCESS](state, action) {
        return {
            ...state,
            allergiesData: action.response,
        };
    },
    [types.MEDICATION_STORED](state, action) {
        return {
            ...state,
            medicationStore: action.response,
        };
    },
    [types.ALLERGIES_STORED](state, action) {
        return {
            ...state,
            allergiesStore: action.response,
        };
    },
    [types.MEDICAL_CONDITION_STORED](state, action) {
        return {
            ...state,
            medicalConditionStore: action.response,
        };
    },
    [types.SYMPTOMS_STORED](state, action) {
        return {
            ...state,
            symptomsStore: action.response,
        };
    },
    //upload medications
    [types.UPLOAD_MEDICATIONS](state, action) {
        return {
            ...state,
            payload: action.payload,
            gender: action.gender,
            token: action.token,
            eligibilityResponse: {},
            userPayload: action.payload,
        };
    },
    [types.UPLOAD_MEDICATIONS_SUCCESS](state, action) {
        return {
            ...state,
            uploadSuccess: action.response
        };
    },
    [types.ENABLE_LOADER](state) {
        return {
            ...state,
            loading: true,
        };
    },
    [types.DISABLE_LOADER](state) {
        return {
            ...state,
            loading: false,
        };
    },
    [types.RESET_PATIENT_DATA]() {
        return {
            loading: false,
            patientDetails: {},
            validateUser: {},
            docList: [],
            roomKeys: [],
            callID: {},
            addUserStatus: {},
            notifyProvider: '',
            roomStatus: {},
            loading: false,
            updateRoomStatusData: {},
            childrenList: [],
            selectedChildData: {},
            consentsData: false,
            consentsSigned: false,
            addChildren: false,
            medicationsData: [],
            allergiesData: {},
            medicationStore: [],
            allergiesStore: [],
            medicalConditionStore: [],
            symptomsStore:[],
            addFamily: false,
        }
    }
});